import { render } from "./LawyersSelectedTopbar.vue?vue&type=template&id=0962ad83&scoped=true"
import script from "./LawyersSelectedTopbar.vue?vue&type=script&lang=js"
export * from "./LawyersSelectedTopbar.vue?vue&type=script&lang=js"

import "./LawyersSelectedTopbar.vue?vue&type=style&index=0&id=0962ad83&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0962ad83"]])

export default __exports__